import React from 'react';
import {FaHandshake, FaProjectDiagram, FaRulerCombined, FaStar} from 'react-icons/fa';
import {useLanguage} from '../contexts/LanguageContext';
import WhyChooseUs from "../components/WhyChooseUs";
import ChooseUs from "../components/ChooseUs";
import CustomerWitness from "../components/CustomerWitness";

interface ContentType {
    title: string;
    description: string;
    stats: {
        partners: string;
        projects: string;
        satisfaction: string;
        area: string;
    }
}

interface ContentMapType {
    [key: string]: ContentType;
}

const content: ContentMapType = {
    en: {
        title: "Booth Construction in America",
        description: "Based in Las Vegas, RunTop LLC is your trusted partner in comprehensive exhibition services across North America. As your premier exhibition partner in the US, we specialize in creating innovative and impactful booth designs that bring your brand vision to life. From concept to completion, we deliver comprehensive exhibition solutions including booth construction, event management, and multilingual support services.",
        stats: {
            partners: "Global Partners",
            projects: "Exhibition Projects",
            satisfaction: "Client Satisfaction",
            area: "Total Build Area"
        }
    },
    zh: {
        title: "北美展台搭建",
        description: "RunTop LLC总部位于拉斯维加斯, 作为您在北美的首选展览合作伙伴，我们专注于创造创新且具有影响力的展台设计，将您的品牌愿景变为现实。从概念到完工，我们提供全面的展览解决方案，包括展台搭建、活动管理和展会翻译服务。",
        stats: {
            partners: "全球合作伙伴",
            projects: "展览项目",
            satisfaction: "客户满意度",
            area: "总搭建面积"
        }
    }
};

const Home: React.FC = () => {
    const {currentLang} = useLanguage();
    const t: ContentType = content[currentLang];

    return (
        <div className="container mx-auto px-4 pt-28">
            {/* 标题和描述部分 */}
            <div className="text-center mb-10 md:mb-20">
                <h1 className="text-3xl md:text-5xl font-bold mb-4 md:mb-6">{t.title}</h1>
                <p className="text-base md:text-xl text-gray-600 max-w-3xl mx-auto px-2">
                    {t.description}
                </p>
            </div>

            {/* 统计数据部分 */}
            <div className="bg-orange-400 rounded-lg p-4 md:p-8">
                <div
                    className="grid grid-cols-2 md:flex md:justify-between items-center gap-6 md:gap-0 max-w-6xl mx-auto">
                    {/* 服务公司数 */}
                    <div className="text-center">
                        <div className="text-white mb-2 md:mb-4 flex justify-center">
                            <FaHandshake className="w-6 h-6 md:w-10 md:h-10"/>
                        </div>
                        <div className="text-2xl md:text-4xl font-bold text-white mb-1 md:mb-2">100+</div>
                        <div className="text-white text-sm md:text-base">{t.stats.partners}</div>
                    </div>

                    {/* 项目数 */}
                    <div className="text-center">
                        <div className="text-white mb-2 md:mb-4 flex justify-center">
                            <FaProjectDiagram className="w-6 h-6 md:w-10 md:h-10"/>
                        </div>
                        <div className="text-2xl md:text-4xl font-bold text-white mb-1 md:mb-2">200+</div>
                        <div className="text-white text-sm md:text-base">{t.stats.projects}</div>
                    </div>

                    {/* 好评度 */}
                    <div className="text-center">
                        <div className="text-white mb-2 md:mb-4 flex justify-center">
                            <FaStar className="w-6 h-6 md:w-10 md:h-10"/>
                        </div>
                        <div className="text-2xl md:text-4xl font-bold text-white mb-1 md:mb-2">99%+</div>
                        <div className="text-white text-sm md:text-base">{t.stats.satisfaction}</div>
                    </div>

                    {/* 搭建面积 */}
                    <div className="text-center">
                        <div className="text-white mb-2 md:mb-4 flex justify-center">
                            <FaRulerCombined className="w-6 h-6 md:w-10 md:h-10"/>
                        </div>
                        <div className="text-2xl md:text-4xl font-bold text-white mb-1 md:mb-2">5000m²+</div>
                        <div className="text-white text-sm md:text-base">{t.stats.area}</div>
                    </div>
                </div>
            </div>
            <div className="relative w-screen left-[50%] right-[50%] mx-[-50vw] bg-[#f5fbff] mt-10 md:mt-20">
                <WhyChooseUs></WhyChooseUs>
            </div>
            <div>
                <ChooseUs></ChooseUs>
            </div>
            <div className="relative w-screen left-[50%] right-[50%] mx-[-50vw] bg-[#f5fbff] mt-10 md:mt-20">
                <CustomerWitness></CustomerWitness>
            </div>
        </div>
    );
}


export default Home;
